module.exports = "pegasus/assets/theme6/medium/4.jpg";